package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AuthRepository

class CompleteSocialSignUpUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(
        name: String,
        studioName: String,
        specialty: String
    ): Result<Unit> {
        val cleanName = name.trim()
        val cleanStudio = studioName.trim()

        if (cleanName.isBlank()) {
            return Result.failure(IllegalArgumentException("Informe o seu nome completo."))
        }
        if (cleanStudio.isBlank()) {
            return Result.failure(IllegalArgumentException("Informe o nome do seu estúdio ou cadeira."))
        }

        return authRepository.completeSocialSignUp(
            name = cleanName,
            studioName = cleanStudio,
            specialty = specialty
        )
    }
}
